import { Flex, Loader } from '@mantine/core';
import { CheckmarkIcon } from '@treams/treams-icons';
import styled from 'styled-components';

const StatusText = styled.p`
	color: ${({ theme }) => theme.colors.slateBlue};
	font-size: 10px;
`;

const StatusIcon = styled.div`
	width: 14px;
	height: 14px;
	align-items: center;
	justify-content: flex-end;
	display: flex;

	svg {
		max-width: 100%;
	}

	svg path {
		fill: ${({ theme }) => theme.colors.slateBlue};
	}
`;

export default function SaveStatus({
	saving,
	dirty,
	changed,
}: {
	saving: boolean;
	dirty: boolean;
	changed: boolean;
}) {
	return (
		<Flex align="center" gap="4px" justify="flex-end">
			{changed && !saving && !dirty && (
				<>
					{/* @TODO: Translate */}
					<StatusText>Opgeslagen</StatusText>
					<StatusIcon>
						<CheckmarkIcon />
					</StatusIcon>
				</>
			)}
			{saving && (
				<>
					{/* @TODO: Translate */}
					<StatusText>Bezig met opslaan</StatusText>
					<StatusIcon>
						<Loader size="12px" color="lightGrey" />
					</StatusIcon>
				</>
			)}
		</Flex>
	);
}
